import React, { useState } from 'react'
import gt from 'ramda/src/gt'
import lt from 'ramda/src/lt'
import useInterval from 'root/src/client/web/hooks/useInterval'
import { daysToSeconds, secondsToDays, secondsTimeFormatted } from 'root/src/shared/util/timeUtil'
import { ternary } from 'root/src/shared/util/ramdaPlus'

const CountdownTimer = ({
	time, expiredStyle, containerStyle, infiniteStyle, textStyle, valueStyle,
}) => {
	const [timeLeft, setTimeLeft] = useState(time)
	const dayInSeconds = daysToSeconds(1)
	const hundredYearsInSec = daysToSeconds(365 * 100)
	const moreThanDay = gt(timeLeft, dayInSeconds)
	const moreThanHundredYears = gt(timeLeft, hundredYearsInSec)
	const expired = lt(timeLeft, 0)

	const timeDisplay = () => {
		if (moreThanHundredYears) {
			return <span className={infiniteStyle}>&#8734;</span>
		}
		if (moreThanDay) {
			return <span className={valueStyle}>{secondsToDays(timeLeft)}</span>
		}

		if (expired) {
			return <span className={expiredStyle}>Expired</span>
		}
		return <span>{secondsTimeFormatted(timeLeft)}</span>
	}

	useInterval(() => {
		setTimeLeft(timeLeft - 1)
	}, 1000)

	return (
		<div className={containerStyle}>
			<span className={textStyle}>
				{ternary(moreThanDay, 'Days To Go', 'Time Left')}
			</span>
			{' '}
			<span className={valueStyle}>
				{timeDisplay()}
			</span>
		</div>
	)
}

export default CountdownTimer
